export default __webpack_public_path__ + "static/media/malayalam.e718f884.svg";